// @ts-check
import { Box, Text } from '~/design-system';
import { Trans } from '@lingui/macro';

/**
 * Renders the match suppliers page, where the suppliers are matched with brand or partner.
 * @param {object} props
 * @param {string} props.supplierName - the name of the selected supplier
 * @param {Array<string | null | undefined>} [props.products] - the product list of the selected supplier
 */

export default function RequestedProducts({ supplierName, products, ...rest }) {
  return (
    <Box sx={{ textAlign: 'left' }} {...rest}>
      <Text>
        <Trans>Supplier</Trans>:{' '}
        <span sx={{ fontWeight: 'bold' }}>{supplierName}</span>
      </Text>
      <Text>Requested products ({products?.length})</Text>
      <ul
        sx={{
          height: '300px',
          overflow: 'scroll',
          display: 'block',
          paddingInlineStart: '20px',
        }}
      >
        {products?.map((product, i) => (
          <li key={i}>
            <Text variant="small">{product}</Text>
          </li>
        ))}
      </ul>
    </Box>
  );
}
